import { pkFormatter } from '../../../../utils/transform';
import { type RouteRoadRangeFormValue } from './schema';
import { type SurveillanceRoutePreset } from '../../../../types/surveillanceRoute';

/** Lo que el formulario necesita saber de una vía: sus extremos declarados. */
export type RoadBounds = {
  id: string;
  name: string;
  pkInitKm: number;
  pkInitMeter: number;
  pkEndKm: number;
  pkEndMeter: number;
};

/**
 * Convierte una plantilla en las filas del asistente.
 *
 * 🔴 Aquí vive la divergencia del modelo: la plantilla guarda un rango por
 * carretera SIEMPRE, mientras que el recorrido, con una sola, lo deja vacío
 * porque su rango son sus propios `pkInit*`/`pkEnd*`. La conversión ocurre en
 * este único sitio; al enviar, `saveData` vuelve a aplicar la regla del
 * recorrido.
 *
 * Los extremos de la vía NO se piden a la red: salen del catálogo que el loader
 * ya trae. Es lo que permite elegir plantilla **sin cobertura**, que es medio
 * motivo de que esto exista — el otro es no teclear el PK con guantes.
 *
 * Una carretera que ya no esté en el catálogo se descarta en vez de reventar el
 * asistente: la plantilla es una comodidad, no una condición para salir.
 */
export const presetToFormRoadRanges = (
  preset: SurveillanceRoutePreset,
  roads: RoadBounds[]
): RouteRoadRangeFormValue[] => {
  const roadById = new Map(roads.map((road) => [road.id, road]));

  return preset.roadIDs.flatMap((roadId) => {
    const road = roadById.get(roadId);
    const range = preset.roadRanges.find((item) => item.roadId === roadId);
    if (!road || !range) return [];

    return [
      {
        roadId,
        pkInit: pkFormatter(range.pkInitKm, range.pkInitMeter),
        pkEnd: pkFormatter(range.pkEndKm, range.pkEndMeter),
        // Cada fila lleva los extremos de SU vía: es lo que hace que
        // `pkValidation` juzgue cada PK contra la carretera correcta y no
        // contra la primera del recorrido.
        pkInitRoad: pkFormatter(road.pkInitKm, road.pkInitMeter),
        pkEndRoad: pkFormatter(road.pkEndKm, road.pkEndMeter),
      },
    ];
  });
};
